<template lang="html">
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>AUDIT TRAIL</b></h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>

        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>

      <template v-slot:cell(role)="data">
        <span v-if="data.value == 1">Admin</span>
        <span v-if="data.value == 2">Stockist</span>
        <span v-if="data.value == 3">Home Dealer</span>
        <span v-if="data.value == 4">Agent</span>
      </template>

      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },

  data() {
    return {
      moment: moment,
      items: [],
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Date", value: "2" }
        ]
      },
      filter2: null,

      form: {
        name: null,
        date: null,
        page: 1
      },

      // Search Index
      indexsearch: 1,

      // Pagination
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },
      fields: [
        {
          label: "No",
          key: "index",
          sortable: false
        },
        {
          label: "User",
          key: "user",
          sortable: true
        },
        {
          label: "Role",
          key: "role",
          sortable: true
        },
        {
          label: "Activity",
          key: "activity",
          sortable: true
        },
        {
          label: "Date",
          key: "date",
          sortable: true
        }
      ],

      isLoading: false,
      fullPage: true
    };
  },

  created() {
    this.getAudit();
  },

  methods: {
    resetFilter() {
      this.form.name = null;
      this.form.date = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.form.date = null;
      this.pagination.current = 1;
      this.getAudit();
    },
    resetIndex() {
      this.indexsearch = 1;
    },

    getAudit() {
      this.isLoading = true;
      this.$store.dispatch("getAudit", this.pagination.current).then(res => {
        this.isLoading = false;
        this.items = [];
        res.data.data.data.forEach(element => {
          this.items.push({
            date: element.created_at,
            activity: element.description,
            user:
              element.userdetails !== null
                ? element.userdetails.name
                : element.log_name,
            role:
              element.userdetails !== null
                ? element.userdetails.access_lvl
                : "",
            id: element.id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },

    onClickSearch() {
      this.isLoading = true;

      let url = "";
      if (this.filter2 === "1") {
        url = `admin/audit?page=${this.indexsearch}&name=${this.form.name}`;
      }
      if (this.filter2 === "2") {
        url = `admin/audit?page=${this.indexsearch}&date=${this.form.date}`;
      }

      if (this.filter2 === null) {
        this.getSubDealer();
      } else {
        this.$store.dispatch("getSearchAudit", url).then(res => {
          this.isLoading = false;
          this.items = [];
          if (res.data.response.code === 100) {
            this.isLoading = false;
            res.data.data.data.forEach(element => {
              this.items.push({
                date: element.created_at,
                activity: element.description,
                user:
                  element.userdetails !== null
                    ? element.userdetails.name
                    : element.log_name,
                role:
                  element.userdetails !== null
                    ? element.userdetails.access_lvl
                    : "",
                id: element.id
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },

    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getAudit();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
